export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000"